import {EmptyMark} from '@/app/utils/string'

export default {
  methods: {
    /**
     * mapper for some object property name to object, which can be used as
     * argument for name-value component
     *
     * @param o                 object, which property should be mapped
     * @param labelKeyPrefix    message key prefix for the label
     * @param valCb             value callback function (possibility to
     *                          transform actual value, e.g. format the value)
     *
     * @return {function(*): {name: *, value: *}}
     */
    propMapper (o, labelKeyPrefix = 'label.', valCb = v =>
      v || (typeof v === 'boolean' ? v : EmptyMark)) {
      return p => ({
        name: this.$t (`${labelKeyPrefix}${p}`),
        value: valCb (o[p])
      })
    }
  }
}
